<template>
  <v-snackbar
    id="allSnackbars"
    v-model="isSnackbarVisible"
    transition="null"
    style="opacity: 0.9; margin: o auto;"
    :width="400"
    :max-width="`${95 *props.vw}`"
    min-width="0"
    :rounded=" (!isScrapAlert && status != 'limited' && !isEmailAlert) ? 'pill' : ''"
    :timeout="3000"
  >

      <div class="text-subtitle-1" :class=" (!isScrapAlert && status != 'limited' && !isEmailAlert) ? 'align-center text-center' : 'pb-2' ">
        <p>{{ snackbarTitle }}</p>
      </div>

      <!-- 북마크 생성 시 갯수 제한 걸렸을 때 alert -->
      <div v-if="status == 'limited'" class="text-subtitle-1 text-center pb-2">
        <p>
          더 이상 북마크를 저장할 수 없습니다.
        </p>
        <p>
          {{`북마크 허용 갯수(${userStore.$isOption(props.roleSelection, 'scrapCount')})를 초과했습니다.`}}
        </p>
      </div>

      <div v-else-if="isScrapAlert" class="">
        <div>
          <p style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            제목 : ({{ userAlertStore.alertForScrapInfo.PageName }}) {{ userAlertStore.alertForScrapInfo.Title }}
          </p>
        </div>
        <p> 발행일 : {{ userAlertStore.alertForScrapInfo.Date }}</p>
        <p> 북마크일 : {{ new Date().format('yyyy-MM-dd') }}</p>
      </div>

      <div v-else-if="isEmailAlert" class="">
        <p> 이름 : {{ userAlertStore.alertForScrapInfo.Alias || '-' }}</p>
        <p> 주소 : {{ userAlertStore.alertForScrapInfo.Address }}</p>
      </div>

    <!-- 알림창 닫기 버튼 -->
    <template #actions>
      <v-btn
        icon
        variant="text"
        class="text-white"
        style="font-size: 24px;"
        @click="handleClose()"
      > ×
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
  import { ref, computed, watch } from "vue";
  import { useUserStore, useUserAlertStore } from '@/store';
  const userStore = useUserStore();
  const userAlertStore = useUserAlertStore();

  const props = defineProps({
    vw: Number,
    roleSelection: String,
  });
  const $emit = defineEmits(['reset-all-alert',]);

  // ==================================================================================

  // 북마크 생성/삭제 시 스낵바 표시 상태
  const isSnackbarVisible = ref(false);
  watch(() => [
                userAlertStore.alertFT.scrap.add,
                userAlertStore.alertFT.scrap.count,
                userAlertStore.alertFT.scrap.delete,
                userAlertStore.alertFT.email.add,
                userAlertStore.alertFT.email.delete,
                userAlertStore.alertFT.email.send,
                userAlertStore.alertFT.keyword.add,
                userAlertStore.alertFT.keyword.delete,
                userAlertStore.alertFT.other.print,
                userAlertStore.alertFT.other.imgDownload,
                userAlertStore.alertFT.other.shareSNS,
                userAlertStore.alertForScrapInfo
              ],
              ([newAdding, newLimited, newRemoving, newEmailAdding, newEmailRemoving, newEmailSending, newKeywordAdding, newKeywordRemoving, newPrinting, newDownloading, newSharing, newInfo]) => {
                if (newInfo != {} && newInfo.status && Object.values(newInfo).every(data => data !== undefined)) { // 모든 알람창 데이터가 제대로 로드되었을 때
                  if ((newAdding && newInfo.status === 'added')                   // 북마크 생성한 경우
                  || (newLimited && newInfo.status === 'limited')                 // 북마크 생성 시 갯수 제한 걸린 경우
                  || (newRemoving && newInfo.status === 'deleted')                // 북마크 삭제한 경우
                  || (newEmailAdding && newInfo.status === 'email-added')         // 메일 주소 추가한 경우
                  || (newEmailRemoving && newInfo.status === 'email-deleted')     // 메일 주소 삭제한 경우
                  || (newEmailSending && newInfo.status === 'email-sent')         // 메일 전송한 경우
                  || (newKeywordAdding && newInfo.status === 'keyword-added')     // 키워드 그룹에 키워드 저장한 경우
                  || (newKeywordRemoving && newInfo.status === 'keyword-deleted') // 키워드 그룹에서 키워드 삭제한 경우
                  || (newPrinting && newInfo.status === 'printed')                // 이미지 프린트한 경우
                  || (newDownloading && newInfo.status === 'imgDownloaded')       // 이미지 다운로드한 경우
                  || (newDownloading && newInfo.status === 'rejected')            // 이미지 다운로드한 경우 - ios(모바일)인 경우 해당 기능 사용 비활성 & 알림 처리 (+)
                  || (newSharing && newInfo.status === 'urlCopied')) {            // url 복사한 경우 - 모바일에서는 알람창 뜨지 않도록 처리 (+)
                    isSnackbarVisible.value = true;
                  }
                } else { isSnackbarVisible.value = false; }
              }, { deep : true, } // userAlertStore.alertForScrapInfo 객체 안까지 감시 가능.
  );

  const status = computed(() => {
    return userAlertStore.alertForScrapInfo.status;
  });
  const isScrapAlert = computed(() => {
    return status.value == 'added' || status.value == 'deleted';
  });
  const isEmailAlert = computed(() => {
    return status.value == 'email-added' || status.value == 'email-deleted';
  });
  const isKeywordAlert = computed(() => {
    return status.value == 'keyword-added' || status.value == 'keyword-deleted';
  });

  // 스낵바 제목 업데이트
  let snackbarTitle = computed(() => {
    switch (status.value) {
      case 'added':
        return '북마크가 생성되었습니다.';
      case 'deleted':
        return '북마크가 삭제되었습니다.';
      case 'email-added':
        return '주소록에서 이메일 주소가 저장되었습니다.';
      case 'email-deleted':
        return '주소록에서 이메일 주소가 삭제되었습니다.';
      case 'keyword-added':
        return '검색 키워드가 저장되었습니다.';
      case 'keyword-deleted':
        return '검색 키워드가 삭제되었습니다.';
      case 'email-sent':
        return '이메일 전송이 완료되었습니다.';
      case 'printed':
        return '선택한 기사를 인쇄합니다.';
      case 'imgDownloaded':
        return '선택한 기사 이미지를 다운로드합니다.';
      case 'rejected':
        return '해당 기능은 iOS에서 지원되지 않습니다.';
      case 'urlCopied':
        return 'URL이 클립보드에 복사되었습니다.';
      default:
        return '';
    }
  });

  // 스낵바 닫기 기능
  function handleClose(){
    isSnackbarVisible.value = false;
    $emit('reset-all-alert');
  };

  // 스낵바 상태 업데이트 시 초기화
  function handleSnackbarUpdate(val) {//val -> v-model 값이 자동으로 인자가 됨
    if (!val) $emit('reset-all-alert');
  }

</script>

<style>

</style>
